(function () {
  'use strict';

  angular.module('datamatic').directive('dmChart', dmChart);

  dmChart.$inject = ['datamatic', '$timeout', '$rootScope'];

  function dmChart(datamatic, $timeout, $rootScope) {
    var directive = {
      link: link,
      restrict: 'EA',
      scope: {
        chartId: '@',
        data: '=',
        height: '=',
        width: '=?',
        chartType: '@?',
        properties: '=?',
      },
    };
    return directive;

    function link(scope, element, attrs, ctrl) {
      var chart = null;

      function initChart() {
        chart = datamatic.chart(scope.chartId, {
          width: scope.width ? scope.width : 680,
          height: scope.height ? scope.height : 450,
        });
        chart.render(element[0]).then(function () {
          chart.setData(scope.data);
          setProperties();
          registerWatch();
          registerOnClick();
        });
      }

      $timeout(function () {
        initChart();
      }, 0);

      function registerWatch() {
        scope.$watch('data', function (newVal, oldVal) {
          if (typeof newVal !== 'undefined') {
            $timeout(function () {
              chart.setData(scope.data);
            }, 0);
          }
        });

        scope.$watch('properties', function (newVal, oldVal) {
          if (typeof newVal !== 'undefined') {
            $timeout(function () {
              setProperties();
            }, 0);
          }
        });
      }

      function registerOnClick() {
        chart.on('click', function (ev) {
          if (ev.componentType == scope.chartType) {
            scope.$emit('chart.click', ev);
          }
        });
      }

      function setProperties() {
        if (Array.isArray(scope.properties)) {
          scope.properties.forEach(function (prop) {
            chart.setProperty(prop.name, prop.value);
          });
        }
      }

      scope.$on('chart.update', function (event) {
        $timeout(function () {
          chart.setData(scope.data);
        }, 0);
      });
    }
  }
})();
